"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartColors = exports.AllChartColors = void 0;
exports.AllChartColors = {
    text: '#444444',
    rim: '#C0C0C0',
    violet: '#834799',
    cyan: '#50C2EE',
    green: '#54B948',
};
exports.ChartColors = [exports.AllChartColors.violet, exports.AllChartColors.cyan, exports.AllChartColors.green];
//# sourceMappingURL=constants.js.map